import { FC, useEffect } from "react";
import { Button } from "../Button";
import store from "../../store/store";
import { openDeactivePopup } from "../../store/reducers/ProductDeletePopup/DeletePopup.slice";


const DeactiveLink: FC<{
  entityData: any;
  entityType: any;
  entityStatus: boolean;
}> = ({ entityData, entityType, entityStatus }) => {
    const openPopup = async (entityData: any, entityType: any, entityStatus: boolean) => {
        const convState = { entityType: entityType, entityData: entityData, entityStatus: entityStatus };
        return store.dispatch(openDeactivePopup(convState));
    }
  return (
    <Button
      onClick={() => {openPopup(entityData, entityType, entityStatus)}}
      apparence={entityStatus ? "success" : "danger"}
      view="default"
      type="submit"
      size="md"
    >
      <div className="font-normal text-base">
        {entityStatus ? "Activate" : "Deactivate"}
      </div>
    </Button>
  );
};

export default DeactiveLink;
